<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Run Script" icon="▶" color="#16a34a">
        <label>File (e.g. /custom.cmd)</label>
        <input type="text"
            :value="props.data.filename ?? ''"
            @input="update('filename', $event.target.value)"
            placeholder="/custom.cmd" />
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
</script>
